import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { login } from 'redux/actions/user.actions'
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Text,
  VStack,
  createStandaloneToast
} from '@chakra-ui/react'
import { Card, CardBody } from '_layout/Card'
import Content from '_layout/Content'
import { IconLogo } from '_base/Icon'
const toast = createStandaloneToast()

function Login({ loading, errors, login }) {
  const [state, setState] = useState({
    email: '',
    password: ''
  })

  const { email, password } = state

  useEffect(() => {
    errors.forEach(error => {
      toast({
        position: 'top',
        description: error.detail,
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    })
  }, [errors])

  const onChangeEmail = event => {
    setState({
      ...state,
      email: event.target.value
    })
  }
  const onChangePassword = event => {
    setState({
      ...state,
      password: event.target.value
    })
  }
  const onSubmit = event => {
    event.preventDefault()
    const email = state.email?.length ? state.email.toLocaleLowerCase() : ''
    login(email, state.password)
  }

  return (
    <Flex direction="column" align="center" h="100vh">
      <Flex w="full" px="4" py="4" align="center" justify="center">
        <a href="https://www.ranktracker.com/" title="Ranktracker">
          <IconLogo fontSize={{ base: '40px', md: '58px' }} color="brand.main" />
        </a>
      </Flex>
      <Content as={Flex} direction="column" flex="1 1 100%" align="center" justify="center">
        <Box w="100%" maxW="420px" transform={{ base: 'translateY(-10%)', md: 'translateY(-15%)' }}>
          <VStack spacing={{ base: 3, md: 5 }} mb={{ base: 5, md: 7 }} textAlign="center">
            <Heading as="h1" fontSize={{ base: '24px', md: '40px' }}>
              Log in
            </Heading>
            <Heading
              as="h2"
              fontSize={{ base: '16px', md: '18px' }}
              color="brand.muted"
              fontWeight="400"
            >
              Welcome to Ranktracker. <br /> All in one optimisation tool.
            </Heading>
          </VStack>
          <Card>
            <CardBody>
              <form onSubmit={onSubmit}>
                <VStack align="left" spacing={{ base: 3, md: 5 }}>
                  <FormControl>
                    <FormLabel htmlFor="email">Email</FormLabel>
                    <Input
                      type="email"
                      name="email"
                      value={email}
                      onChange={onChangeEmail}
                      required
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel htmlFor="password">Password</FormLabel>
                    <Input
                      type="password"
                      name="password"
                      value={password}
                      onChange={onChangePassword}
                      required
                    />
                  </FormControl>
                  <FormControl>
                    <Button size="lg" w="full" type="submit" isDisabled={loading}>
                      Log in
                    </Button>
                  </FormControl>
                  <FormControl textAlign="center">
                    <Text fontSize="xs" color="brand.muted">
                      Trouble signing in?{' '}
                      <Link
                        href="https://www.ranktracker.com/forgotten-password/"
                        color="brand.link"
                      >
                        Reset your password
                      </Link>
                    </Text>
                    <Text fontSize="xs" color="brand.muted">
                      Don't have an account?{' '}
                      <Link href="https://www.ranktracker.com/pricing/" color="brand.link">
                        Sign Up
                      </Link>
                    </Text>
                  </FormControl>
                </VStack>
              </form>
            </CardBody>
          </Card>
        </Box>
      </Content>
    </Flex>
  )
}

const mapStateToProps = state => ({
  loading: state.user.loading,
  errors: state.user.errors
})
const mapDispatchToProps = dispatch => ({
  login: (email, password) => dispatch(login(email, password))
})
export default connect(mapStateToProps, mapDispatchToProps)(Login)
